import { Control } from 'ol/control';
import {Emitter} from "../base/emitter";

class SideBarControl extends Control {
    private sidebar: HTMLDivElement;
    private emitter: Emitter;

    constructor(emitter: Emitter) {
        const element = document.createElement('div');
        element.className = 'cfm-sidebar hidden';

        super({
            element: element,
        });

        this.emitter = emitter;

        this.sidebar = element;

        this.emitter.on('sidebarShow', this.showPanel.bind(this));
        this.emitter.on('sidebarHide', this.hidePanel.bind(this));
    }

    private hidePanel(): void {
        this.sidebar.className = 'cfm-sidebar hidden';
    }

    private showPanel(): void {
        this.sidebar.className = 'cfm-sidebar visible';
    }
}

export default SideBarControl;
